import { useState } from 'react';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import promotionsTypeInfo from './PromotionsTypeInfo';

const PopoverWithCloseButton = ({ promoType }: { promoType: string }) => {
  const [popoverOpen, setPopoverOpen] = useState(false);

  const togglePopover = () => setPopoverOpen(!popoverOpen);

  const promoData = promotionsTypeInfo.find(
    (promo) => promo.promoType === promoType
  );

  if (!promoData) {
    return null;
  }
  const id = `PopoverPromoTypeInfo-${promoType}`;

  return (
    <>
      <i
        id={id}
        className="bx bx-info-circle"
        style={{
          cursor: 'pointer',
          fontSize: '1.5rem',
          color: '#a3a6b7',
        }}
        onClick={togglePopover}
      ></i>

      <Popover
        placement="right"
        isOpen={popoverOpen}
        target={id}
        toggle={togglePopover}
        fade={false}
      >
        <PopoverHeader
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <span dangerouslySetInnerHTML={{ __html: promoData.title }}></span>
          <i
            className="ri-close-line"
            style={{
              cursor: 'pointer',
              float: 'right',
              fontSize: '1.2rem',
            }}
            onClick={togglePopover}
          ></i>
        </PopoverHeader>

        <PopoverBody dangerouslySetInnerHTML={{ __html: promoData.body }} />
      </Popover>
    </>
  );
};

export default PopoverWithCloseButton;
